export default {
  items: [
    {
      name: "Dashboard CEO",
      url: "/admin/dashboard-ceo",
      icon: "isax-category-2",
      meta: {
        allowAccess: ["CEO"],
        page: "admin",
        code: ["*"],
        collection: "DashboardCEO",
      },
    },
    {
      name: "Dashboard HR",
      url: "/admin/dashboard-hr",
      activeurl: [
        "/admin/dashboard-hr",
        "/admin/dashboard-hr?role=Recruit",
        "/admin/dashboard-hr?role=Payroll",
        "/admin/dashboard-hr?role=Administrative",
      ],
      icon: "isax-category-2",
      meta: {
        allowAccess: ["HR"],
        page: "admin",
        code: ["*"],
        collection: "DashboardHR",
      },
    },
    {
      name: "Dashboard cá nhân",
      url: "/admin/dashboard-individual",
      icon: "isax-category-2",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "DashboardIndividual",
      },
    },
    {
      name: "Công ty",
      url: "/admin/System/Company/list",
      icon: "isax-building",
      meta: {
        allowAccess: ["FT001", "FT002", "FT003", "FT004", "FT2302", "FT2303", "FT2304", "FT2305", "FT2306"],
        page: "admin",
        code: ["FT001", "FT002", "FT003", "FT004", "FT2302", "FT2303", "FT2304", "FT2305", "FT2306"],
        collection: 'Company'
      }
    },
    {
      name: "Văn bản điện tử",
      url: "/admin/DocumentsGeneral",
      icon: "isax-directbox-notif",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "Document",
      },
    },
    {
      name: "Hợp đồng điện tử",
      url: "/admin/document-drafting/list",
      icon: "isax-sms-tracking",
      meta: {
        allowAccess: ["CEO", "HR", "KD"],
        page: "admin",
        code: ["*"],
        collection: "DocumentDrafting",
      },
    },
    {
      name: "Quản lý công việc",
      url: "/admin/AssignWork",
      icon: "isax-message",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "AssignWork",
      },
    },

    {
      name: "Chấm công",
      url: "/admin/intermediary",
      icon: "isax-user-cirlce-add",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "Timekeeping",
      },
    },
    {
      name: "Kinh doanh",
      url: "/admin/business/list",
      icon: "isax-money-4",
      meta: {
        allowAccess: ["KD"],
        page: "admin",
        code: ["FT2001"],
        collection: "Business",
      },
    },
    {
      name: "Tin tức",
      url: "/admin/news/list",
      icon: "isax-device-message",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["FT2200"],
        collection: "News",
      },
    },
  ],
};
